import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const CloseConfirmationDialog = ({ show, onHide, onCancel, onClose }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            dialogClassName="modal-md"
            aria-labelledby="close-confirmation-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title id="close-confirmation-modal">
                    Confirm Close
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-0">
                    Are you sure you want to close this variation? Any unsaved changes will be lost.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={onClose}>
                    Close Without Saving
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default CloseConfirmationDialog